// extracted by mini-css-extract-plugin
export var jobBoardContainer = "JobBoard-module--jobBoardContainer--1nYzk";
export var noResultText = "JobBoard-module--noResultText--2sfFo";
export var headingRow = "JobBoard-module--headingRow--kKz9T";
export var openPositionCount = "JobBoard-module--openPositionCount--1aTVy";
export var jobBoard = "JobBoard-module--jobBoard--2tSmh";
export var departmentRow = "JobBoard-module--departmentRow--6pn6a";
export var department = "JobBoard-module--department--1P2Sp";
export var role = "JobBoard-module--role--3F8SH";
export var location = "JobBoard-module--location--3HdMN";
export var roleType = "JobBoard-module--roleType--1EOup";